import React from "react";
import Select from "react-select";
import NavHeader from "./NavHeader";

// Un partido: equipos local/visitante + hora + cancha.
// La carga de resultados (marcador/goleadores) se maneja en otra sección.
export default function MatchScreen({ match, zoneTeamIds, teams, onChange, onBack }) {
  const getTeamById = (teamId) => teams.find((t) => t.id === teamId);

  const teamKey = (side) => (side === "home" ? "homeTeamId" : "awayTeamId");
  const goalsKey = (side) => (side === "home" ? "homeGoals" : "awayGoals");

  const teamOptions = zoneTeamIds
    .map((id) => getTeamById(id))
    .filter(Boolean)
    .map((t) => ({ value: t.id, label: t.name }));

  const selectedOption = (teamId) => {
    const t = getTeamById(teamId);
    return t ? { value: t.id, label: t.name } : null;
  };

  const canchaOptions = [1, 2, 3, 4].map((n) => ({ value: n, label: "Cancha " + n }));

  const setTeam = (side, option) => {
    const teamId = option ? option.value : "";
    // Cambiar de equipo limpia los goles de ese lado (quedaban asociados al equipo
    // anterior) y el walk-over, que era de los equipos que estaban antes.
    onChange({ ...match, [teamKey(side)]: teamId, [goalsKey(side)]: [], wo: "" });
  };

  const homeTeam = getTeamById(match.homeTeamId);
  const awayTeam = getTeamById(match.awayTeamId);
  const title = homeTeam && awayTeam ? homeTeam.name + " vs " + awayTeam.name : "Partido";

  const renderTeamSelect = (side, label) => (
    <div className="form-group mb-0">
      <label className="font-weight-bold" style={{ fontSize: "0.8125rem" }}>
        {label}
      </label>
      <Select
        isSearchable={true}
        placeholder={"Seleccioná el " + label.toLowerCase() + "..."}
        classNamePrefix="react-select"
        name={"team-" + side}
        value={selectedOption(match[teamKey(side)])}
        onChange={(option) => setTeam(side, option)}
        options={teamOptions}
        noOptionsMessage={() => "Sin equipos"}
      />
    </div>
  );

  return (
    <div className="screen-slide">
      <NavHeader title={title} onBack={onBack} />

      <div className="card mb-3">
        <div className="card-body">
          <div className="row">
            <div className="col-6">{renderTeamSelect("home", "Local")}</div>
            <div className="col-6">{renderTeamSelect("away", "Visitante")}</div>
          </div>
        </div>
      </div>

      <div className="card mb-3">
        <div className="card-body">
          <div className="row">
            <div className="col-6">
              <div className="form-group mb-0">
                <label className="font-weight-bold" style={{ fontSize: "0.8125rem" }}>
                  Hora
                </label>
                <input
                  type="time"
                  className="form-control"
                  value={match.hora || ""}
                  onChange={(e) => onChange({ ...match, hora: e.target.value })}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group mb-0">
                <label className="font-weight-bold" style={{ fontSize: "0.8125rem" }}>
                  Cancha
                </label>
                <Select
                  isSearchable={false}
                  isClearable={true}
                  placeholder="N°..."
                  classNamePrefix="react-select"
                  name="selectCancha"
                  value={canchaOptions.find((o) => String(o.value) === String(match.cancha)) || null}
                  onChange={(opt) => onChange({ ...match, cancha: opt ? opt.value : "" })}
                  options={canchaOptions}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
